// extracted by mini-css-extract-plugin
module.exports = {"modal":"SupportModal_modal__Ooeu0","footer":"SupportModal_footer__lNnIs"};